import { allPartOfTheDay } from '../_const/PartOfTheDay.ts';
import type { DayRow } from '../dto/ItineraryData.dto.ts';

const orderActivitiesByPartOfDay = (activities: DayRow[]): DayRow[] => {
  const hasUnknown = activities.some(
    (activity) => !allPartOfTheDay.includes(activity.part_of_the_day),
  );

  if (hasUnknown) return activities;

  return [...activities].sort(
    (a, b) =>
      allPartOfTheDay.indexOf(a.part_of_the_day) -
      allPartOfTheDay.indexOf(b.part_of_the_day),
  );
};

export default orderActivitiesByPartOfDay;
